import { createFileRoute } from '@tanstack/react-router'
import { MonitorsListView } from '@/components/monitors-list'

export const Route = createFileRoute('/_authenticated/dashboard/browser-checks/')({
  component: () => <MonitorsListView category="browser" />,
})
